



































import SelectBase from './select-base'

import store from '@/store'

queryKeyword = (keyword) ->
  if keyword? and keyword.length > 0 then "keyword: \"Keyword>>>#{keyword}\"" 
  else ""

query = (keyword) -> (
  "query timezones {
    timezones( #{queryKeyword keyword} ) { recordset { Name Value } }
  }"
)

export default {
  name: 'SelectTimezones'
  mixins: [SelectBase]
  props: {
    valueField: { type: String, default: () => 'Value' },
  }

  methods: {
    _fetch: (value)-> (
      self = this
      { timezones } = await store.dispatch 'centric2', { query: (query value) }
      if timezones?
        timezones.recordset = timezones.recordset.map (node) -> self.modifyOpt node
        timezones
      else { recordset: [] }
    )
    modifyOpt: (option) ->
      option.Label = "#{option.Name} (#{option.Value})"
      option
  }
}
